import { Injectable } from '@angular/core';
import { ClickStreamControllerService, ClickStreamEventDto } from '@enauka/api';
import { KONFIGURACJA, KonfiguracjaService } from '@enauka/shared/konfiguracja';
import { CommonData } from '@enauka/shared/util';
import formatISO from 'date-fns/formatISO';

@Injectable({
  providedIn: 'root'
})
export class ClickStreamService {
  private uuid = CommonData.uuid();
  private stopped = false;
  private events: ClickStreamEventDto[] = [];
  private intervalHandle: any;
  private readonly BUFFOR_SIZE = 1000;
  clickstreamWlaczony = false;
  clickstreamInterval: number;
  poczatkowyInterwal: number;

  constructor(
    private clickStreamControllerService: ClickStreamControllerService,
    private konfiguracjaService: KonfiguracjaService) {
    this.konfiguracjaService.subscribe(konfiguracja => {
      this.clickstreamWlaczony = konfiguracja.getBoolean(KONFIGURACJA.CLICKSTREAM_WLACZONY);
      this.clickstreamInterval = konfiguracja.getInt(KONFIGURACJA.CLICKSTREAM_INTERVAL);
      this.poczatkowyInterwal = konfiguracja.getInt(KONFIGURACJA.CLICKSTREAM_INTERVAL);
    });
  }

  add(event: { jsonType: any; }) {
    if (this.events.length > this.BUFFOR_SIZE) {
      this.events.splice(0, this.events.length - this.BUFFOR_SIZE + 100);
    }
    this.events.push({
      uuid: this.uuid,
      value: JSON.stringify(event),
      typ: event.jsonType,
      czas: formatISO(new Date())
    });
  }

  flush() {
    return this.send();
  }

  restart() {
    this.stop();
    this.start();
  }

  private send() {
    const toSend = this.events;
    this.events = [];
    if (!toSend.length || this.stopped)
      return Promise.resolve();
    this.clickStreamControllerService.saveUsingPOST(toSend)
      .subscribe(() => {
      }, (error) => {
        this.events.unshift(...toSend);
        this.tryLater();
      });
  }

  private start() {
    this.stopped = false;
    if (this.clickstreamWlaczony) {
      let sekundy = this.clickstreamInterval;
      if (sekundy < 5 || isNaN(sekundy))
        sekundy = 60;
      const interval = sekundy * 1000;
      this.intervalHandle = setInterval(() => {
        if (!this.stopped) {
          this.send();
        }
      }, interval);
    };
  }

  private stop() {
    this.stopped = true;
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
    }
  }
  private tryLater() {
    this.clickstreamInterval = this.clickstreamInterval * 2;
    if (this.clickstreamInterval > 600) {
      this.clickstreamInterval = this.poczatkowyInterwal;
    }
    this.restart();
  }
}
